import RefreshControl from './RefreshControl'
import InfiniteScroll from './InfiniteScroll'
import { isNotNull } from '@/utils/tools'

export default {
  name: 'list-view',
  props: {
    refreshing: Boolean,
    ...InfiniteScroll.props,
    finished: Boolean
  },
  data () {
    return {
      trigger: null
    }
  },
  mounted () {
    this.trigger = this.$el
  },
  render (h) {
    return h('div', {
      staticClass: 'load-more'
    }, [
      isNotNull(this.$listeners.refresh) ? h(RefreshControl, {
        props: {
          refreshing: this.refreshing,
          trigger: this.trigger
        },
        on: {
          refresh: () => this.$emit('refresh')
        }
      }) : undefined,
      this.$slots.default,
      isNotNull(this.$listeners.load) && !this.finished ? h(InfiniteScroll, {
        props: {
          loading: this.loading,
          loadingText: this.loadingText
        },
        on: {
          load: () => this.$emit('load')
        }
      }) : undefined
    ])
  }
}



// WEBPACK FOOTER //
// ./src/components/list-view/LoadMore.js